<template>
  <div v-if="showing" class="spinner">
    <div class="msg">
      Cargando datos ...
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showing: false
    };
  },
  mounted() {
    let vm = this;
    this.$eventBus.$on("spinner-on", function() {
      console.log("muestro spinner");
      vm.showing = true;
    });

    this.$eventBus.$on("spinner-off", function() {
      vm.showing = false;
      console.log("oculto spinner");
    });
  }
};
</script>

<style lang="scss" scoped>
.spinner {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
}

.msg {
  background: rgba(0, 0, 0, 0.5);
  font-size: 2.5rem;
  border-radius: 5px;
  color: white;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  padding: 1rem;
}
</style>
